<template>
  <v-navigation-drawer :value="isDrawerOpen" app floating width="260" class="app-navigation-menu" :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)">
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5">
      <router-link to="/" class="d-flex align-center text-decoration-none">
        <!-- <v-img
          :src="require('@/assets/images/logos/logo-small.png')"
          max-height="30px"
          max-width="150px"
          alt="logo"
          contain
          eager
          class="app-logo me-3"
        ></v-img> -->
        <v-slide-x-transition>
          <h2 class="app-title text--primary">SIOPAK TEGAL</h2>
        </v-slide-x-transition>
      </router-link>
    </div>
    <div class="ps-6 pe-5">
      <span class="text--primary font-weight-semibold mb-n1">
        {{ user.username }}
      </span>
      <br /><small class="text-capitalize">{{ user.role }}</small>
    </div>
    <!-- Navigation Items -->
    <!-- <v-list expand shaped class="vertical-nav-menu-items pr-0">
      <nav-menu-link title="Dashboard" :to="{ name: 'dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
    </v-list> -->
    <v-list v-if="user.role == 'ADMIN'" expand shaped class="vertical-nav-menu-items pr-0">
      <nav-menu-link title="Dashboard" :to="{ name: 'dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
      <nav-menu-link title="Surat Pengantar" :to="{ name: 'AdminSuratPengantar' }"
        :icon="icons.mdiEmailBox"></nav-menu-link>
      <nav-menu-link title="Praktik" :to="{ name: 'AdminPraktik' }" :icon="icons.mdiAccountCogOutline"></nav-menu-link>
      <nav-menu-link title="Pengguna" :to="{ name: 'User' }" :icon="icons.mdiAccountCogOutline"></nav-menu-link>
      <nav-menu-group title="Master" :icon="icons.mdiFileOutline">
        <nav-menu-link title="Universitas" :to="{ name: 'MasterUniversitas' }"></nav-menu-link>
        <nav-menu-link title="Program Studi" :to="{ name: 'MasterProdi' }"></nav-menu-link>
        <nav-menu-link title="Pilihan Praktik/Stase" :to="{ name: 'MasterStase' }"></nav-menu-link>
        <nav-menu-link title="Pilihan Dokdiknis" :to="{ name: 'MasterDokdiknis' }"></nav-menu-link>
        <nav-menu-link title="Pilihan Ruang" :to="{ name: 'MasterRuangan' }"></nav-menu-link>
        <nav-menu-link title="Kuesioner Link" :to="{ name: 'MasterKuesionerLink' }"></nav-menu-link>
      </nav-menu-group>
    </v-list>
    <v-list v-if="user.role == 'PESERTA DIDIK' && user.verified_at != null" expand shaped
      class="vertical-nav-menu-items pr-0">
      <nav-menu-link title="Dashboard" :to="{ name: 'dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
      <nav-menu-link title="Praktik" :to="{ name: 'UserPraktik' }" :icon="icons.mdiAccountCogOutline"></nav-menu-link>
      <nav-menu-link title="Kuesioner" :to="{ name: 'KuesionerLink' }"
        :icon="icons.mdiAccountCogOutline"></nav-menu-link>
    </v-list>
    <v-list v-if="user.role == 'PEMBIMBING KLINIK' && user.verified_at != null" expand shaped
      class="vertical-nav-menu-items pr-0">
      <nav-menu-link title="Dashboard" :to="{ name: 'dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
      <nav-menu-link title="Pengembangan Diri" :to="{ name: 'PembimbingPengembanganDiri' }"
        :icon="icons.mdiAccountCogOutline"></nav-menu-link>
      <nav-menu-link title="Praktik" :to="{ name: 'PembimbingPraktik' }"
        :icon="icons.mdiAccountCogOutline"></nav-menu-link>
    </v-list>
    <v-list v-if="user.role == 'UNIVERSITAS' && user.verified_at != null" expand shaped
      class="vertical-nav-menu-items pr-0">
      <nav-menu-link title="Dashboard" :to="{ name: 'dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
      <nav-menu-link title="Surat Pengantar" :to="{ name: 'UniversitasSuratPengantar' }"
        :icon="icons.mdiEmailBox"></nav-menu-link>
      <nav-menu-link title="Praktik" :to="{ name: 'UniversitasPraktik' }"
        :icon="icons.mdiAccountCogOutline"></nav-menu-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiEmailBox,
} from '@mdi/js'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiEmailBox,
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;

  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  background: white !important;
}

.v-application--is-ltr .v-list.v-sheet--shaped .v-list-item,
.v-application--is-ltr .v-list.v-sheet--shaped .v-list-item::before,
.v-application--is-ltr .v-list.v-sheet--shaped .v-list-item>.v-ripple__container {
  border-bottom-right-radius: 0px !important;
  border-top-right-radius: 0px !important;
}
</style>
